import * as types from './mutation-types'

export default {
    [types.SET_CURRENT_BATCH] (state, batch) {
        state.currentBatch = batch
    },
    [types.SET_HISTORY] (state, history) {
        state.history = history || []
    },
    [types.SET_IS_POLLING] (state, value) {
        state.isPolling = !!value
    },
    [types.SET_IS_DISPATCHING] (state, value) {
        state.isDispatching = !!value
    },
    [types.SET_IS_CANCELLING] (state, value) {
        state.isCancelling = !!value
    },
}
